/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Api_SyncInputs */

const en_svchip_api_sync = /** @type {(inputs: Svchip_Api_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API sync`)
};

const ar_svchip_api_sync = /** @type {(inputs: Svchip_Api_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مزامنة الواجهات`)
};

const bn_svchip_api_sync = /** @type {(inputs: Svchip_Api_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API সিঙ্ক`)
};

const de_svchip_api_sync = /** @type {(inputs: Svchip_Api_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Synchronisierung`)
};

const es_svchip_api_sync = /** @type {(inputs: Svchip_Api_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización API`)
};

const fr_svchip_api_sync = /** @type {(inputs: Svchip_Api_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisation de l'API`)
};

const pt_svchip_api_sync = /** @type {(inputs: Svchip_Api_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronização de API`)
};

const zh_svchip_api_sync = /** @type {(inputs: Svchip_Api_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 同步`)
};

const tr_svchip_api_sync = /** @type {(inputs: Svchip_Api_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API senkronizasyonu`)
};

const ru_svchip_api_sync = /** @type {(inputs: Svchip_Api_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-синхронизация`)
};

const pl_svchip_api_sync = /** @type {(inputs: Svchip_Api_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizacja API`)
};

/**
* | output |
* | --- |
* | "API sync" |
*
* @param {Svchip_Api_SyncInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_api_sync = /** @type {((inputs?: Svchip_Api_SyncInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Api_SyncInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_api_sync(inputs)
	if (locale === "bn") return bn_svchip_api_sync(inputs)
	if (locale === "de") return de_svchip_api_sync(inputs)
	if (locale === "es") return es_svchip_api_sync(inputs)
	if (locale === "fr") return fr_svchip_api_sync(inputs)
	if (locale === "pt") return pt_svchip_api_sync(inputs)
	if (locale === "zh") return zh_svchip_api_sync(inputs)
	if (locale === "tr") return tr_svchip_api_sync(inputs)
	if (locale === "ru") return ru_svchip_api_sync(inputs)
	if (locale === "pl") return pl_svchip_api_sync(inputs)
	return en_svchip_api_sync(inputs)
});